<ng-container *ngIf="product$ | async as product">
  <ng-container *ngIf="product">
    <h2 class="text-capitalize">{{ product.name }}</h2>
    <div class="d-flex align-items-center justify-content-between mt-5 mb-1">
      <ng-container *ngIf="!product?.redPrice?.formattedValue">
        <h3 class="price">
          {{ product.price?.formattedValue }}
        </h3>
        <p class="small" *ngIf="product.code; else noCode">ID | {{ product.code }}</p>
        <ng-template #noCode></ng-template>
      </ng-container>
      <ng-container *ngIf="product?.redPrice?.formattedValue">
        <h3 class="price price--promo">
          <span class="price__current">{{ product?.redPrice?.formattedValue }}</span>
          <span class="price__divider"></span>
          <span class="price__old detailPrice">{{ product.price.formattedValue }}</span>
        </h3>

        <div class="description" style="border-bottom: none; margin-left: auto; font-size: 12px">
          <span class="sku" *ngIf="product.code; else noCode">ID | {{ product.code }}</span>
          <ng-template #noCode></ng-template>
        </div>
      </ng-container>
    </div>
    <hr />
  </ng-container>
</ng-container>

<cx-carousel
  [title]="'Productos Alternativos'"
  *ngIf="items$ | async as items"
  [items]="items"
  [template]="carouselItem"
  itemWidth="200px"
>
</cx-carousel>

<hr *ngIf="(items$ | async)?.length" />

<ng-template #carouselItem let-item="item">
  <cx-product-carousel-item [item]="item"></cx-product-carousel-item>
</ng-template>